import { Text } from "@growtherapy/sprout-ui";
import { faCircleMinus } from "@fortawesome/pro-solid-svg-icons";
import {
  TRANSCRIPTION_DISABLED,
  TRANSCRIPTION_NOT_AVAILABLE_FOR_MULTIPLE_PARTICIPANTS,
} from "./constants";
import { ModifiedToastAria, Toast, ToastVariant } from "../../toasts";

export function RecordingControlMultipleParticipantsToast({
  contentProps,
  descriptionProps,
  titleProps,
  ...toastAriaProps
}: ModifiedToastAria) {
  return (
    <Toast {...toastAriaProps} variant={ToastVariant.Info} icon={faCircleMinus}>
      <div {...contentProps}>
        <span className="sr-only" {...titleProps}>
          {TRANSCRIPTION_DISABLED}
        </span>
        <Text as="span" {...descriptionProps}>
          {TRANSCRIPTION_NOT_AVAILABLE_FOR_MULTIPLE_PARTICIPANTS}
        </Text>
      </div>
    </Toast>
  );
}
